import {Component, EventEmitter, Inject, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material";
import {ModalComponent} from "../modal/modal.component";
import {ApiService} from "../api.service";
import * as moment from "moment";
import {_} from "underscore";
import {RequestBodyVacations} from '../InjectionVO';
import {ModalTadHoursComponent} from '../modal-tad-hours/modal-tad-hours.component';
import {UserService} from '../../../service/UserService';
import {AuthService} from '../../../auth/services/auth.service';
import {FeatureAccessService} from '../../../service/feature-access.service';

@Component({
  selector: 'injection-root',
  templateUrl: './injection-root.component.html',
  styleUrls: ['./injection-root.component.css'],
  entryComponents: [ModalComponent],
  encapsulation: ViewEncapsulation.None
})
export class InjectionRootComponent implements OnInit {
  public _data: any;
  nonEmptyVacationList : boolean = false;
  isShowInjection : boolean = false;
  countryCode : string = "";
  profile : string = "";
  @Input()
  locked : boolean = false;
  @Input()
  displayInjectRealisedButton : boolean;

  isAlreadyInjected : boolean = false;
  matriculeTimesheet = "";
  @Input()
  set isValidateBlockTemps(state : boolean){
    this._isValidateBlockTemps = state;
  }
  _isValidateBlockTemps : boolean = false;


  @Output()
  refreshData : EventEmitter<any> = new EventEmitter<any>();
  @Input() component: "historyByDate" | "buttonModal";
  @Input()
  set data(_data: any) {
    this.update(_data);
    console.log("_data : ",_data);
    if (_data && _data.user)
    {
      this.matriculeTimesheet = _data.user.username;
      this.getCurrentVacations(_data);
      this.checkISAlreadyInjected(_data);
      this.checkIsShowInjectionButton(_data);
    }
  }
  @Output() event: EventEmitter<any> = new EventEmitter<any>();
  histories: any = [];

  injectionDate: RequestBodyVacations = new RequestBodyVacations();
  constructor(public dialog: MatDialog, private api: ApiService,private userService: UserService, private auth: AuthService) {}

  async ngOnInit() {

  }
  async update(_data) {
    if(this.component == "historyByDate") {
      const {date, status, userName} = _data;
      if(userName && status && date) {
        const history = await this.api.getHistory(userName, moment(date).format("YYYY-MM-DD"), status);
       this.histories = _.sortBy(history, 'createdAt').filter(e => e.version)
      }
    } else {
      this._data = _data
    }
  }
  openDialog() {
    this._data.injectionData = this.injectionDate;
    const dialogRef = this.dialog.open(ModalComponent, {
      data: this._data,
      panelClass: 'cdk-modal-injection',
    });
    dialogRef.afterClosed().subscribe(e=> {
      if(e){
        this.refreshData.emit();
      }
    });
  }
  openDialogTadHour() {
    this._data.injectionData = this.injectionDate;
    this._data['readonly'] = this._isValidateBlockTemps;
    const dialogRef = this.dialog.open(ModalTadHoursComponent, {
      data: this._data,
      width: '600 !important',
      height: '560px !important',
      panelClass: 'cdk-modal-injection',
    });
    dialogRef.afterClosed().subscribe(e=> {
      if(e){
        this.refreshData.emit();
      }
    });
  }

  fireEvent(event: any) {
    event.spinner = true;
    this.histories.forEach(e => { e.selected = event.id == e.id;});

    event.dispatch = (ev) => {
      setTimeout(() => {
        event.spinner = ev;
      }, 1e2);
    }

    this.event.emit(event);
  }

  private getCurrentVacations(_data:any) {
    const matricule = _data.user.username;
    const date = moment(_data.user.date).format("YYYY-MM-DD");
    this.api.getCurrentVacationsV2(matricule,date).subscribe(response=> {
      this.nonEmptyVacationList = response && response.vacationAndPausesVo &&
        response.vacationAndPausesVo.vacations &&
        response.vacationAndPausesVo.vacations.length>0
      this.injectionDate = response;
    })
  }
  private checkISAlreadyInjected(_data:any) {
    const matricule = _data.user.username;
    const date = moment(_data.user.date).format("YYYY-MM-DD");
    this.api.checkISAlreadyInjected(matricule,date).subscribe(response=> this.isAlreadyInjected = response)
  }

  private checkIsShowInjectionButton(_data:any) {
    const matricule = _data.user.username;
    const date = moment(_data.user.date).format("YYYY-MM-DD");
    this.api.getIsShowInjection(matricule,date).subscribe(response=> {
      this.isShowInjection = response;
    })
  }
  get hasCountry() {
    const collaborator = this.userService.getUser();
    const countryCode: string = collaborator.countryCode;
    return countryCode;
  }

  // Méthode pour vérifier si un pays peut injecter le réaliser
  verifierInjection(){
    if (JSON.parse(localStorage.getItem("DETAILS"))) {
      this.countryCode = this.userService.getUserCountry();
      this.profile = JSON.parse(localStorage.getItem("DETAILS")).profile;
      return  this.profile && this.profile.toLowerCase() != "ci" &&
        FeatureAccessService.hasAccess('INJECTER_REALISE',this.countryCode.toUpperCase())
    }
    return false;
  }

  canShowTadButton() {
    let tadblockExist = null;
    if( this._data) {
      tadblockExist = this._data.temps_data.find((block) => block.legend === "FULFILLED_VALIDATED_INSERVICE_TAD");
    }
    return this._isValidateBlockTemps && !tadblockExist   ? false : true;
  }

  // Check that TL type is PROD or Hors PROD
  checkTlIsProd(){
    return this.auth.checkTlIsProd() && this.userService.getCurrentUser('userName') !== this.matriculeTimesheet;
  }

  protected readonly FeatureAccessService = FeatureAccessService;
}



// WEBPACK FOOTER //
// ./src/app/modules/injection/injection-root/injection-root.component.ts